import { COOKIE_CONNECT_WALLET } from "../constants";

export class CookieService {
  static cookieExists(cookieName: string): boolean {
    const cookies = document.cookie;
    const cookieArray: string[] = cookies
      .split(";")
      .map((item: string) => item.trim());

    return cookieArray.some((cookie: string) => cookie.startsWith(cookieName));
  }

  static setCookie(
    name: string,
    value: any,
    expiresMs = 365 * 24 * 60 * 60 * 1000
  ) {
    if (!value) {
      CookieService.deleteCookie(name);
    } else {
      if (
        CookieService.cookieExists(COOKIE_CONNECT_WALLET) ||
        name === COOKIE_CONNECT_WALLET
      ) {
        const d = new Date();
        d.setTime(d.getTime() + expiresMs);
        const expires = "expires=" + d.toUTCString();
        document.cookie =
          name +
          "=" +
          (value ? value : "") +
          ";expires=" +
          expires +
          ";path=/;SameSite=Strict;Secure";
      }
    }
  }

  static deleteCookie(name: string) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
  }
}
